import { useState } from 'react'
import { Button, Dialog, Typography } from '@mui/material'
import OverlayLoading from 'components/atoms/OverlayLoading'
import InCardStack from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { patchRequest } from 'utils/api'
import {
  USER_CONNECTION_URL,
  USER_CONNECTION_RELATIONSHIP
} from 'services/constants'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import {
  ConnectionRow,
  UpdateConnectionPopupBody,
  SkipPopup
} from 'components/molecules/myTeam/ImportPopupMolecules'

const ImportOneOnOneUpdateConn = ({
  open,
  setOpen,
  inDirectCandidates,
  successCallback,
  closeImport
}) => {
  const { t } = useTranslation()
  const [connections, setConnections] = useState(inDirectCandidates)
  const [selected, setSelected] = useState(null)
  const [showSkip, setShowSkip] = useState(false)
  const [loading, setLoading] = useState(false)

  const closePopup = () => {
    setSelected(null)
    setShowSkip(false)
    setOpen(false)
  }

  const UpdateConnectionPopup = () => {
    const handleUpdateConn = async () => {
      setLoading(true)
      const res = await patchRequest(
        `${USER_CONNECTION_URL}/${selected?.userConnectionId}`,
        {
          relationship: USER_CONNECTION_RELATIONSHIP[0].value
        }
      )
      if (res?.status === 200) {
        setConnections(
          connections.map(c =>
            c.userConnectionId === selected.userConnectionId
              ? { ...c, relationship: USER_CONNECTION_RELATIONSHIP[0].value }
              : c
          )
        )
        setSelected(null)
      }
      setLoading(false)
    }
    return (
      <UpdateConnectionPopupBody
        selected={selected}
        setSelected={setSelected}
        handleUpdateConn={handleUpdateConn}
      />
    )
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setOpen(false)
          }
        }}>
        <OverlayLoading open={loading} />
        <InCardStack
          spacing={6}
          sx={{
            width: 440,
            alignItems: 'flex-start',
            padding: 12
          }}>
          {selected ? (
            <UpdateConnectionPopup />
          ) : showSkip ? (
            <SkipPopup
              setShowSkip={setShowSkip}
              onConfirm={() => {
                closePopup()
                closeImport()
              }}
            />
          ) : (
            <>
              <Typography variant='h4'>
                {t('calendarEvents.updateConnectionStatus')}
              </Typography>
              <Typography>
                {t('calendarEvents.attendeesNotMarkedDirect')}
              </Typography>
              <Typography>
                {t('calendarEvents.ensureImportUpdateConnectionStatus')}
              </Typography>

              <InCardStack
                spacing={6}
                sx={{
                  width: '100%',
                  alignItems: 'flex-start',
                  paddingY: 12,
                  borderTop: `1px solid ${colors.Grey100}`,
                  borderBottom: `1px solid ${colors.Grey100}`
                }}>
                {connections.map(c => (
                  <ConnectionRow
                    key={c?.userConnectionId}
                    c={c}
                    setSelected={setSelected}
                  />
                ))}
              </InCardStack>
              <RowStack spacing={6} justifyContent='center'>
                <Button
                  size='small'
                  color='muted'
                  onClick={() => setShowSkip(true)}>
                  {t('addRaters.skipForNow')}
                </Button>
                <Button
                  size='small'
                  onClick={() => {
                    closePopup()
                    successCallback()
                  }}
                  disabled={connections?.every(
                    c =>
                      c.relationship !== USER_CONNECTION_RELATIONSHIP[0].value
                  )}>
                  {t('common.continue')}
                </Button>
              </RowStack>
            </>
          )}
        </InCardStack>
      </Dialog>
    </>
  )
}

export default ImportOneOnOneUpdateConn
